import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';


export default class FtueButton extends Component {

    constructor(props) {
        super(props);
        this.app = this.props.app;
        this.authenticator = this.app.state.authenticator;
        let enabled = this.authenticator.account.ftue;
        this.state = { enabled: enabled };
    }

    toggle = () => {
        let enabled = !this.state.enabled;
        this.authenticator.account.ftue = enabled;
        this.setState({ enabled: enabled }, this.send);
    };

    send = () => {
        let typeName = 'FTUE';
        let packageValue = {};
        this.authenticator.sendMessage(typeName, packageValue);
    }

    render() {
        return <Button variant={'honored'}
                       onClick={this.toggle}>
            Tutorial Mode is {this.state.enabled ? 'On' : 'Off'}
        </Button>;
    }
}

export class FtueQuestionMark extends FtueButton {
    render() {
        return <span onClick={this.toggle}>
            {this.state.enabled ? <>&iquest;</> : '?'}
        </span>;
    }
}




